import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchDoctors } from "../apis/doctorService";
import { IDoctorState, IDoctorsFetchApiResponse } from "../interfaces/IDoctor";

const initialState: IDoctorState = {
  availableDoctor: [],
  isLoading: false,
};

export const getDoctors = createAsyncThunk(
  "doctor/getDoctors",
  async ({
    search,
    accessToken,
    hospitalId,
  }: {
    search: string;
    accessToken: string;
    hospitalId: number | string | undefined;
  }) => {
    const resp = await fetchDoctors(search, hospitalId);
    return resp;
  }
);

const doctorSlice = createSlice({
  name: "doctor",
  initialState,
  reducers: {
    resetAvailableDoctors: (state) => {
      state.availableDoctor = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDoctors.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(
        getDoctors.fulfilled,
        (state, action: PayloadAction<IDoctorsFetchApiResponse>) => {
          state.isLoading = false;
          state.availableDoctor = action.payload.availableDoctor;
        }
      )
      .addCase(getDoctors.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const {resetAvailableDoctors} = doctorSlice.actions;
export default doctorSlice.reducer;
